import { Injectable } from '@angular/core';
import { AssessRequestRaService } from '../../assess-request-ra/assess-request-ra.service';

/**
 * Service for binding Information and MultiLimit comment columns
 * Handles hyperlink extraction, comment transformation, and HTML preparation for dialogs
 * Usage: Call bindInformationAndRuleResultColumns(dataArray, assessRequestRaService) - returns processed data
 */
@Injectable({
  providedIn: 'root'
})
export class ColumnBindingService {
  ruleResultsOptions = [{ value: 10, label: 'No issues identified' }, { value: 20, label: 'Warnings' }, { value: 30, label: 'Failed' }, { value: 60, label: 'Additional Information' }];

  constructor(
    public assessRequestRaService: AssessRequestRaService
  ) { }


    bindInformationAndRuleResultColumns(data: any[]) {
      for (const obj of data) {
        // Bind RuleResult Column
        if (obj.ruleStatusId) {
          const ruleResultOption = this.ruleResultsOptions.find(option => option.value === obj.ruleStatusId);
          obj.ruleResult = ruleResultOption ? ruleResultOption.label : '';
        }

        // Bind Information Column
        if (obj.information) {
          obj.multiLimitRuleInfoText = obj.information;
          obj.originalInformation = obj.multiLimitRuleInfoText;
          let allLinksCombined = '';
          const informationLinkRuleData = this.assessRequestRaService.hyperLinksToSheet(obj.multiLimitRuleInfoText);

          allLinksCombined = informationLinkRuleData
            .filter(item => item && item.hyperlink)
            .map(item => item.hyperlink) // extract only hyperlink
            .join(', ');

          obj.multiLimitRuleInfoText = this.changeComment(obj.multiLimitRuleInfoText);
          obj.informationStripped = this.handleSpecialCharacters(obj.originalInformation);

          obj.informationTextWithLink = obj.informationStripped;
          if (allLinksCombined) {
            obj.informationTextWithLink += ' :: All links: ' + allLinksCombined;
          }
        }
      }
      return data;
    }


  private changeComment(input) {
    const strValue = input;
    const ar = strValue ? strValue.match(/<a.*?<\/a>/g) : null;
    let commentwarning = '';
    if ((ar !== null) && (ar.length === 0 || ar.length > 0)) {
      commentwarning = 'Click Here';
    } else {
      commentwarning = input;
    }
    return commentwarning;
  }


  private handleSpecialCharacters(text) {
    if (text) {
      return text.replace(/<.*?>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, '').replace(/&amp;/g, '&');
    }
  }

}
